/**
 * Global Admin/Agent mode switch.
 *
 * Scoped to agents with can_edit_defaults (today: just Todd) - everyone
 * else never sees the switch and this always reads as agent mode. Persisted
 * in localStorage so it survives reloads, but reset back to agent mode the
 * moment can_edit_defaults itself goes false (e.g. viewing as a different,
 * non-admin account) so a stale "admin" flag can't leak into an account
 * that shouldn't have it.
 *
 * Deliberately a standalone module (not page-local state) - this needs to
 * be readable from the sidebar (which pages/nav items show), the header
 * (badge), and any future page that should behave differently for admins,
 * without those places importing each other.
 */

const STORAGE_KEY = 'agent-admin-mode';

let canEditDefaults = false;

export function setCanEditDefaults(value: boolean): void {
  canEditDefaults = value;
  if (!value) {
    localStorage.removeItem(STORAGE_KEY);
  }
}

export function canUseAdminMode(): boolean {
  return canEditDefaults;
}

export function isAdminMode(): boolean {
  return canEditDefaults && localStorage.getItem(STORAGE_KEY) === 'true';
}

export function setAdminMode(enabled: boolean): void {
  if (!canEditDefaults) return;
  localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(new CustomEvent('admin-mode-change', { detail: { enabled: isAdminMode() } }));
}
